import { Component, inject, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterOutlet,
} from '@angular/router';
import { filter } from 'rxjs/operators';
import { LanguageService } from './services/language.service';
import { ThemeService } from './services/theme.service';
import { SeoInput, SeoService } from './services/seo.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  private language = inject(LanguageService);
  private theme = inject(ThemeService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private seo = inject(SeoService);

  ngOnInit(): void {
    this.language.init();
    this.theme.init();

    // Aplicar SEO de la ruta actual (incluye el render SSR inicial) y en cada
    // navegación de cliente. Las páginas con datos (p.ej. gremio) lo sobreescriben.
    this.applySeoFromRoute();
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => this.applySeoFromRoute());
  }

  private applySeoFromRoute(): void {
    let route = this.route;
    while (route.firstChild) {
      route = route.firstChild;
    }
    const seo = route.snapshot.data['seo'] as SeoInput | undefined;
    if (seo) {
      this.seo.update({
        ...seo,
        path: seo.path ?? this.router.url.split('?')[0],
      });
    }
  }
}
